import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Form } from 'element-ui';
declare var _hmt: any;
@Component

export default class addMoreTeacherForm extends Vue {
    addLoading: Boolean = false;
    editLoading: Boolean = false;
    listLoading: Boolean = false;
    teacherFormList: Array<any> = [];
    dialogPassword: Boolean = false;
    dialogGroup: Boolean = false;
    visibleNewGroup: String = 'visibleGroup';
    visibleOldGroup: String = 'visibleGroup';
    dynamicValidateForm: Array<any> = [];
    groupList: Array<any> = [];
    editList: Array<any> = [];
    fileList: Array<any> = [];
    isDisable = false;//防止按钮重复点击
    groupRadio: String = '';
    txtNewGroup: string = '';
    selOldGroup: String = '';
    index: number = 0;
    accountRestCount: number = 0;
    currAccountName: string = '';
    fullscreenLoading: Boolean = false; //全屏遮罩
    loadingText: string = '请稍等';//全屏遮罩提示
    btnAddGroup: Boolean = true;
    btnPassword: Boolean = true;
    btnDelete: Boolean = true;
    repeatTip: string = '该账号名已存在';
    passwordForm = {
        password: ''
    }
    errorMsg: string = '';
    $refs: {
        multipleTable: Form,
        passwordForm: Form,
    };

    passwordFormRules: Object = {
        password: [
            {
                required: true,
                validator: (rule, value, callback) => {
                    if (value === '') {
                        callback(new Error('请输入密码'));
                    } else if (!/^[\w]{6,20}$/.test(value)) {
                        callback(new Error('密码为6-20位字符，只能由英文字母大小写、数字、下划线（无空格）组成'));
                    } else {
                        callback();
                    }
                },
                trigger: 'blur'
            }
        ]
    }

    handleSelectionChange(val) {

        this.editList = val;
        let seleList = this.editList;
        if (seleList.length > 0) {

            this.btnAddGroup = false;
            this.btnPassword = false;
            this.btnDelete = false;
        } else {
            this.btnAddGroup = true;
            this.btnPassword = true;
            this.btnDelete = true;
        }
    }

    getTeachList() {

        this.axios.get('/api/groups/').then((data) => {
            this.groupList = data.data;
            let groupId = data.data[0] && data.data[0].groupId;

            this.teacherFormList = [{
                'accountName': '',
                'realName': '',
                'password': '',
                'allocateCount': '', //分配余额
                'groupId': groupId,
                'validate': '',
                'index': this.index,
                'createTime': this.utilFun.formatDate(new Date()),
                'tipdisabled': true,
                'tipcontent': '请输入内容',
                'tipAccountDisabled': true,
                'tipRealNameDisabled': true,
                'tipPasswordDisabled': true,
            }]
        })
    }

    selectGroup() {
        this.txtNewGroup = '';
        this.selOldGroup = '';
        if (this.groupRadio == '1') {
            this.visibleNewGroup = '';
            this.visibleOldGroup = 'visibleGroup';
        } else {
            this.visibleNewGroup = 'visibleGroup';
            this.visibleOldGroup = '';
        }
    }

    jump(url) {
        this.$router.push({
            path: url,
            query: {}
        });
    }

    //添加到组
    onGropSubmit() {
        if (this.groupRadio == '1') {
            let groupName = this.txtNewGroup;

            if (!/^[\S]{2,20}$/.test(groupName)) {
                this.$message({
                    message: '分组名为2-20位字符，中文，英文，数字及符号（无空格）',
                    type: 'error'
                });
                return;
            }

            let para;
            para = {
                "GroupName": groupName
            };
            let _itemThis = this;
            this.axios.post('/api/groups?GroupName=' + groupName, para).then((data) => {
                if (data != undefined && data != '' && data.data != '412') {
                    this.getGroupList();
                    let groupId = data.data;
                    this.editList.forEach(item => {
                        var index = this.teacherFormList.indexOf(item);
                        this.teacherFormList[index].groupId = groupId;
                    })

                    this.dialogGroup = false;
                } else {
                    _itemThis.$message({
                        message: '该分组名已存在',
                        type: 'error'
                    });
                }

            }).catch(function (response) {
                _itemThis.$message({
                    message: '添加分组失败',
                    type: 'error'
                });
                return;
            })

        } else if (this.groupRadio == '2') {
            let groupId = this.selOldGroup;

            this.editList.forEach(item => {
                var index = this.teacherFormList.indexOf(item);
                this.teacherFormList[index].groupId = groupId;
            })
            this.dialogGroup = false;
        }
    }

    beforeUpload(file) {

        let isDoc = true;
        const isLt10M = file.size / 1024 / 1024 < 10;
        const fileName = file.name;
        var AllImgExt = ".xls|.xlsx|";
        var extName = fileName.substring(fileName.lastIndexOf(".")).toLowerCase();//（把路径中的所有字母全部转换为小写）          
        if (AllImgExt.indexOf(extName + "|") == -1) {
            isDoc = false;
        }

        if (!isDoc) {
            this.$message.error('上传文件格式不正确!');
        }
        if (!isLt10M) {
            this.$message.error('上传文件大小不能超过 10MB!');
        }
        return isDoc && isLt10M;
    }

    handleError(err, file, fileList) {
        if (err.status == 412) {
            this.$message.error(err.message);
        } else {
            this.$message.error('上传文件失败!');
        }
    }

    initUploaderFile() {
        let webUploaderOpt = {
            auto: true, // 是否自动上传
            fileSingleSizeLimit: 30 * 1024 * 1024,
            fileSingleSizeLimitStr: '30M',
            fileNumLimit: 500,
            multiple: true,
            threads: 1,
            swf: '/static/Uploader.swf?_t=' + new Date().getTime(),
            server: 'api/accounts/upload',
            pick: '#file_upload',
            resize: false,
            duplicate: true,
            accept: {
                title: 'Documents',
                extensions: 'xlsx,xls',
                mimeTypes: '.xlsx,.xls'
            }
        };
       
        let WebUploader: any = (<any>window).WebUploader;
        let uploader = WebUploader.create(webUploaderOpt);
        uploader.on('beforeFileQueued', (file) => {

            _hmt.push(['_trackEvent', '课程作业_教师账号管理', '（批量）上传模板', '事件价值', 1]);

            this.fullscreenLoading = true;
            this.errorMsg = '';
            if (file.size == 0) {
                this.$message({
                    message: '文件为0kb上传失败',
                    type: 'error'
                });
                this.fullscreenLoading = false;
                return false;
            } else {
                // this.beforeUpload(file);
            }
        });
        uploader.on('uploadSuccess', (file, response) => {
            this.fullscreenLoading = false;
            this.handleAvatarSuccess(response, file);
         
        });
        uploader.on('uploadError', (file, reason) => {
            this.fullscreenLoading = false;
            this.errorMsg = this.errorMsg == '' ? '上传文件失败' : this.errorMsg;

            this.$message({
                message: this.errorMsg,
                type: 'error'
            });
          
        });
        //接收后台响应结果
        uploader.on('uploadAccept', (obj, ret) => {
            this.errorMsg = ret;
        });
        uploader.on('error', (error) => {
            this.fullscreenLoading = false;
            if (error == 'Q_EXCEED_NUM_LIMIT') {
            } else if (error == 'Q_TYPE_DENIED') {
                this.$message({
                    message: '只允许excel文件上传',
                    type: 'error'
                });
            } else if (error == 'F_EXCEED_SIZE') {
            }
           
        });
        uploader.on("uploadFinished",  ()=> {
            this.fullscreenLoading = false;
            uploader.reset();
        });
    }

    async onSubmitTeacher() {

        if (this.teacherFormList.length > 200) {
            this.$message({
                message: '最多导入200条数据',
                type: 'error'
            });
            return;
        }

        this.isDisable = true;
        let result = true;
        let model = (<any>Object).assign([], this.teacherFormList);
        let errorTip = '内容不能为空';
        //let repeatTip = '该账号名已存在';
        let warnTip_accountName = '账户名为4-16位字符，至少包含一个数字或字母，且不能以下划线开头';
        let warnTip_password = '密码为6-20位字符，只能由英文字母大小写、数字、下划线（无空格）组成';
        let warnTip_realName = '姓名为2-10位中文（无空格）';
        let warnTip_groupId = '分组不能为空';
        let warnTip_allotCount = '分配余额为正数';
        var rule_accountName = /^(?!_)(?=.*[A-Za-z])(?=.*\d)[\w]{4,16}$/;
        var rule_password = /^[\w]{6,20}$/;
        var rule_realName = /^[\u4E00-\u9FA5]{2,10}$/;
        var rule_allotCount = /^[1-9]*[1-9][0-9]*$/;

        let messageIip = '';

        var accountNameList = [];
        this.fullscreenLoading = true;
        this.loadingText = '正在校验数据，请稍后';
        for (var item of this.teacherFormList) {
            if (item.accountName == '') {
                this.setTipMessage(item, 'vldAccountName', 'validate_warn', false, errorTip);
                result = false;
                messageIip = errorTip;
                break;

            } else if (!rule_accountName.test(item.accountName)) {
                this.setTipMessage(item, 'vldAccountName', 'validate_error', false, warnTip_accountName);
                result = false;
                messageIip = warnTip_accountName;
                break;
            }
            let marks = await this.axios.post('api/accounts/accountName/' + this.currAccountName + '.' + item.accountName).then((data) => {
                if (!data) {
                    return false;
                } else if (data.data == '') {
                    return true;
                };
            })
            if (!marks) {
                this.setTipMessage(item, 'vldAccountName', 'validate_repeat', false, this.repeatTip);
                result = false;
                messageIip = this.repeatTip;
                break;
            }
            else {
                this.setTipMessage(item, 'vldAccountName', '', true, '');
            }

            if (item.realName == '') {
                this.setTipMessage(item, 'vldRealName', 'validate_warn', false, errorTip);
                result = false;
                messageIip = errorTip;
                break;
            } else if (!rule_realName.test(item.realName)) {

                this.setTipMessage(item, 'vldRealName', 'validate_error', false, warnTip_realName);
                result = false;
                messageIip = warnTip_realName;
                break;
            } else {
                this.setTipMessage(item, 'vldRealName', '', true, '');
            }

            if (item.password == '') {
                this.setTipMessage(item, 'vldPassword', 'validate_warn', false, errorTip);
                result = false;
                messageIip = errorTip;
                break;
            } else if (!rule_password.test(item.password)) {
                this.setTipMessage(item, 'vldPassword', 'validate_error', false, warnTip_password);
                result = false;
                messageIip = warnTip_password;
                break;
            } else {
                this.setTipMessage(item, 'vldPassword', '', true, '');
            }

            if (item.allocateCount == '') {
                this.setTipMessage(item, 'vldAllocateCount', 'validate_warn', false, errorTip);
                result = false;
                messageIip = errorTip;
                break;
            } else if (!rule_allotCount.test(item.allocateCount)) {
                this.setTipMessage(item, 'vldAllocateCount', 'validate_error', false, warnTip_allotCount);
                result = false;
                messageIip = warnTip_allotCount;
                break;
            } else {
                this.setTipMessage(item, 'vldAllocateCount', '', true, '');
            }

            if (item.groupId == undefined || item.groupId == '') {
                this.setTipMessage(item, 'vldGroupId', 'validate_warn', false, warnTip_groupId);
                result = false;
                messageIip = warnTip_groupId;
                break;
            } else {
                this.setTipMessage(item, 'vldGroupId', '', true, '');
            }

            accountNameList.push(item.accountName);
        }

        let arr = this.uniqueValid(accountNameList);
        this.loadingText = '正在提交，请稍后';
        if (arr.length > 0) {
            this.setTipMessage(this.teacherFormList[arr[0]], 'vldAccountName', 'validate_warn', false, warnTip_accountName);
            this.setTipMessage(this.teacherFormList[arr[1]], 'vldAccountName', 'validate_warn', false, warnTip_accountName);
            result = false;
            messageIip = "账号名重复";
        }

        if (!result) {
            this.$message({
                message: messageIip,
                type: 'warning'
            });
            this.isDisable = false;
            this.fullscreenLoading = false;
            return;
        } else {
            let totalCount = 0;
            model.forEach(item => {
                item.status = 1,
                    item.subUserId = this.currAccountName + '.' + item.accountName,
                    item.accountType = 'Teacher',
                    totalCount += parseInt(item.allocateCount)
            })

            if (totalCount > this.accountRestCount) {
                this.$message({
                    message: '分配余额超出限制',
                    type: 'warning'
                });
                this.isDisable = false;
                this.fullscreenLoading = false;
                return;
            }

            this.axios.post('/api/accounts?mark=Teacher', model).then((data) => {
                this.fullscreenLoading = false;
                this.isDisable = false;
                if (data == undefined) {
                    this.$message({
                        message: '提交失败',
                        type: 'error'
                    });
                } else {
                    if (data.data.stateCode == undefined) {
                        if (data.data['errorUsers'] == '' && data.data['exsitUsers'] != '') {
                            this.$message({
                                message: data.data['exsitUsers'] + '用户名已存在',
                                type: 'error'
                            });
                        } else if (data.data['errorUsers'] != '') {
                            this.$message({
                                message: '添加失败',
                                type: 'error'
                            });
                        } else {
                            this.$message({
                                message: '提交成功',
                                type: 'success'
                            });

                            this.$router.push({
                                path: '/teacheraccounts',
                                query: {}
                            });
                        }
                    }
                    else if (data.data.stateCode == '412') {
                        this.$message({
                            message: data.data.message,
                            type: 'error'
                        });
                    } else {

                        this.$message({
                            message: '提交成功',
                            type: 'success'
                        });

                        this.$router.push({
                            path: '/teacheraccounts',
                            query: {}
                        });
                    }


                }

            })
        }
    }

    setTipMessage(item, itemName, itemVld, tipDis, tipContent) {
        this.$set(item, itemName, itemVld);
    }

    getGroupList() {
        this.axios.get('/api/groups').then((data) => {
            this.groupList = data.data;
        })
    }

    addRow() {

        _hmt.push(['_trackEvent', '课程作业_教师账号管理', '批量新增', '事件价值', 1]);

        if (!this.ValidityEmpty()) {
            this.$alert('请先填写当前新条目后再添加', '提示', {
                confirmButtonText: '确定',
            });
            return;
        }
        let groupIndex = this.groupList[0] ? this.groupList[0].groupId : '';
        this.index += 1;
        this.teacherFormList.push({
            'accountName': '',
            'realName': '',
            'password': '',
            'mycss': '',
            'allocateCount': '', //分配余额
            'index': this.index,
            'groupId': groupIndex,
            'createTime': new Date(),
            'tipAccountDisabled': true,
            'tipRealNameDisabled': true,
            'tipPasswordDisabled': true,
        })
        this.teacherFormList.push({});
        this.teacherFormList.pop();
    }

    ValidityEmpty() {
        let result = true;
        this.teacherFormList.forEach(item => {
            if (item.accountName == '' || item.realName == '') {
                result = false;
            }
        })
        return result;
    }

    onAddGroup() {
        this.selOldGroup = '';
        this.txtNewGroup = '';
        if (this.editList.length == 0) {
            this.$alert("请选择要分组的账号", '提示').catch(() => { });
            return false;
        }
        this.dialogGroup = true;
    }

    onSetPassword() {
        if (this.editList.length == 0) {
            this.$alert("请选择要修改密码的账号", '提示').catch(() => { });
            return false;
        }
        this.dialogPassword = true;
        this.$refs['passwordForm'].resetFields();
    }

    onPasswordSubmit() {
        this.$refs.passwordForm.validate((valid) => {
            if (!valid) {
                return;
            } else {
                this.editList.forEach(item => {
                    var index = this.teacherFormList.indexOf(item);
                    this.teacherFormList[index].password = this.passwordForm.password;

                })
                this.dialogPassword = false;
            }
        });

    }

    onDelete() {

        if (this.editList.length == 0) {
            this.$alert("请选择要修改密码的账号", '提示').catch(() => { });
            return false;
        } else {
            this.editList.forEach(item => {
                var index = this.teacherFormList.indexOf(item);
                this.teacherFormList.splice(index, 1);
            });
            this.editList = [];
        }
    }

    onDownload() {
        window.location.href = "teacher.xlsx";
    }

    handleAvatarSuccess(res, file) {
        if (res.length > 200) {
            this.$message({
                message: '最多导入200条数据',
                type: 'error'
            });
            return;
        }
        for (var i = 0; i < this.teacherFormList.length; i++) {
            if (this.teacherFormList[i].accountName == '' &&
                this.teacherFormList[i].realName == '' &&
                this.teacherFormList[i].password == '') {
                this.teacherFormList.splice(i, 1);
            }
        }
        res.forEach(item => {
            let groupIndex = this.groupList[0].groupId;
            item.groupId = groupIndex;
            this.teacherFormList.push(item);
        })
    }

    uniqueValid(arr) {
        var res = [];
        var json = {};
        var double = {};
        for (var i = 0; i < arr.length; i++) {
            if (!json[arr[i]]) {
                json[arr[i]] = 1;
                double[arr[i]] = i;
            } else {
                res.push(double[arr[i]]);
                res.push(i);
                break;
            }
        }
        return res;
    }

    getAccountInfo() {
        this.axios.get('/api/accounts/GetAccountInfo').then((data) => {
            if (data.status == 200) {
                let result = data.data;
                this.currAccountName = result.userId;
                this.accountRestCount = result.balance;
            }
        })
    }

    mounted() {
        this.getAccountInfo();
        this.getTeachList();
        this.initUploaderFile();
    }
}